module.exports = __webpack_public_path__ + "img/UVC41.b68ffc92.png";